module.exports = __webpack_public_path__ + "img/boiler-second.d31db297.webp";